export const getUsage = async (meterName, customerId, subscriptionId) => {
  const url = `/api/meter?meterName=${meterName}&customerId=${customerId}&subscriptionId=${subscriptionId}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Failed to fetch usage data");
  }
  const data = await response.json();
  return data.data;
};

export const sendEvent = async (eventData) => {
  const url = `/api/meter/`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(eventData),
  });
  if (!response.ok) {
    throw new Error("Failed to send event");
  }
  const data = await response.json();
  return data;
};
